export default "__VITE_ASSET__eeb03daa__"